import Box from '@mui/material/Box'
import Button from '@mui/material/Button'
import Typography from '@mui/material/Typography'
import { BrandGridSkeleton } from '@/shared/components/skeletons'
import type { ISpRewardBrand } from '@brushfire/types'
import { selectBrandGridSx } from '../styles/selectBrandStyles'
import { BrandCard } from '../components/BrandCard'

export function renderBrandGridSection(input: {
  brandsLoading: boolean
  filteredBrands: ISpRewardBrand[]
  visibleBrands: ISpRewardBrand[]
  search: string
  hasMore: boolean
  onSelect: (brand: ISpRewardBrand) => void
  onLoadMore: () => void
}) {
  if (input.brandsLoading) {
    return <BrandGridSkeleton />
  }

  if (input.filteredBrands.length === 0) {
    const emptyMessage = input.search.trim()
      ? `No brands found for "${input.search.trim()}". Try a different search.`
      : 'No brands available for your current balance.'

    return (
      <Typography
        sx={{ color: '#64748b', textAlign: 'center', py: 4 }}
        data-testid="rewards-brand-empty"
      >
        {emptyMessage}
      </Typography>
    )
  }

  return (
    <>
      <Box sx={selectBrandGridSx} data-testid="rewards-brand-grid">
        {input.visibleBrands.map((brand) => (
          <BrandCard key={brand.productId} brand={brand} onSelect={input.onSelect} />
        ))}
      </Box>

      {input.hasMore && (
        <Box sx={{ display: 'flex', justifyContent: 'center', mt: 3, mb: 4 }}>
          <Button
            variant="outlined"
            onClick={input.onLoadMore}
            data-testid="rewards-brand-load-more"
            sx={{ borderRadius: '10px', textTransform: 'none', fontWeight: 600, px: 4 }}
          >
            Load More
          </Button>
        </Box>
      )}
    </>
  )
}
